import script from "./MemberDetailClosingHistory.vue?vue&type=script&setup=true&lang=ts"
export * from "./MemberDetailClosingHistory.vue?vue&type=script&setup=true&lang=ts"

import "./MemberDetailClosingHistory.vue?vue&type=style&index=0&id=06383160&lang=scss"

const __exports__ = script;

export default __exports__